/**
 * Maps help topic ids to the permissions that gate the matching features.
 * A topic is visible when the user has ANY listed permission (OR).
 * Overview is always available to authenticated users.
 */
export const topicAccess = {
  overview: {
    // Always visible when authenticated
  },
  timesheet: {
    permissions: ['PERM_USER_TIMESHEET']
  },
  leave: {
    permissions: ['PERM_USER_TIMESHEET'],
    requireTrackLeave: true
  },
  expenses: {
    permissions: ['PERM_USER_EXPENSES']
  },
  'expense-wizard': {
    permissions: ['PERM_USER_EXPENSES']
  },
  'travel-expense': {
    permissions: ['PERM_USER_EXPENSES']
  },
  'general-business': {
    permissions: ['PERM_USER_EXPENSES']
  },
  'other-direct-costs': {
    permissions: ['PERM_USER_EXPENSES']
  },
  review: {
    permissions: ['PERM_REVIEW_TIMESHEETS']
  },
  profile: {
    permissions: ['PERM_USER_PROFILE']
  },
  'admin-dashboard': {
    permissions: ['PERM_ADMIN_DASHBOARD']
  },
  customers: {
    permissions: ['PERM_VIEW_CUSTOMERS']
  },
  contracts: {
    permissions: ['PERM_VIEW_CONTRACTS']
  },
  projects: {
    permissions: ['PERM_VIEW_PROJECTS']
  },
  'funding-obligations': {
    permissions: ['PERM_VIEW_PROJECT_FUNDING', 'PERM_MANAGE_PROJECT_FUNDING_DETAILS']
  },
  'charge-codes': {
    permissions: ['PERM_VIEW_CHARGE_CODES']
  },
  employees: {
    permissions: ['PERM_VIEW_EMPLOYEES']
  },
  invoices: {
    permissions: ['PERM_VIEW_INVOICES']
  },
  'invoice-create-wizard': {
    permissions: ['PERM_CREATE_INVOICE', 'PERM_VIEW_INVOICES']
  },
  'expense-review': {
    permissions: ['PERM_MANAGE_EMPLOYEE_EXPENSES']
  },
  'expense-import': {
    permissions: ['PERM_MANAGE_EMPLOYEE_EXPENSES']
  },
  payroll: {
    permissions: ['PERM_ACCOUNTING_INTEGRATION']
  },
  reports: {
    permissions: ['PERM_VIEW_REPORTS']
  },
  integrations: {
    permissions: ['PERM_MANAGE_INTEGRATIONS']
  },
  quickbooks: {
    permissions: ['PERM_MANAGE_INTEGRATIONS']
  },
  paylocity: {
    permissions: ['PERM_MANAGE_INTEGRATIONS']
  },
  permissions: {
    permissions: ['PERM_MANAGE_PERMISSIONS']
  },
  settings: {
    permissions: ['PERM_VIEW_COMPANY_SETTINGS', 'PERM_MANAGE_COMPANY_SETTINGS']
  },
  'company-benefits': {
    permissions: ['PERM_MANAGE_COMPANY_SETTINGS']
  },
  'data-management': {
    permissions: ['PERM_ACCOUNTING_INTEGRATION', 'PERM_MANAGE_PERMISSIONS']
  },
  subcontractors: {
    permissions: ['PERM_MANAGE_COMPANY_SETTINGS', 'PERM_VIEW_CUSTOMERS']
  }
};

export function getTopicAccess(topicId) {
  return topicAccess[topicId] || { permissions: ['__NONE__'] };
}



// WEBPACK FOOTER //
// ./client/help/content/access.js